import React from 'react';

import Image from '../../../../library/image/image';

import './studdable-image.scss';

function StuddableImage() {
  return (
    <Image
      alt="Studdable"
      height="24"
      src="https://discounttire.scene7.com/is/content/discounttire/logos/icons/feature-icon_studdable-tire.svg"
      styleName="studdable-image"
      width="24"
    />
  );
}

export default StuddableImage;
